import script from "./PartnerProjectLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectLayout.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectLayout.vue?vue&type=style&index=0&id=6c2fa755&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2fa755"]])

export default __exports__